export const footerData = [
  {
    id: 1,
    title: "main",
    items: [
      {
        id: 2,
        isSection: true,
        title: "library",
        parentPath: "",
        path: "https://lib.renessans-edu.uz/",
        isExternal: true,
      },
      {
        id: 6,
        isSection: true,
        title: "news",
        parentPath: "",
        path: "news",
      },
      {
        id: 8,
        isSection: true,
        title: "partners",
        parentPath: "",
        path: "partners",
      },
    ],
  },
  {
    id: 2,
    title: "courses",
    items: [
      {
        id: 11,
        isSection: true,
        title: "list",
        parentPath: "courses",
        path: "category",
      },
      {
        id: 41,
        isSection: true,
        title: "approach",
        parentPath: "courses",
        path: "approach",
      },
      {
        id: 51,
        isSection: true,
        title: "questions",
        parentPath: "courses",
        path: "question",
      },
    ],
  },
  {
    id: 3,
    title: "others",
    items: [
      {
        id: 2534,
        isSection: false,
        title: "contact",
        path: "contact"
      }
    ],
  },
];
